<style lang="scss" scoped>
.panel {
	&__flag {
		margin-right: 15px;
		position: relative;
		margin-top: -2px;
	}
}
</style>

<template lang="pug">
    el-card.panel
        table.data
            tr
                td Name
                td {{ school.name }}
            tr
                td URN
                td {{ school.urn }}
            tr
                td Phase of education
                td {{ school.phase_of_education }}
            tr
                td Local Authority
                td {{ school.la_name || "N/A" }} 
                    span(v-if="school.la_code") - {{ school.la_code }}
                    span(v-if="school.establishment_number") /{{ school.establishment_number }}
            tr
                td Address
                td {{ school.address_line_1 }} {{ school.address_line_2 }} {{ school.address_town }} {{ school.address_postcode }}
            tr
                td Country
                td 
                    flag(:code="school.country_iso_3166_2").panel__flag
                    | {{ school.country_name }}
</template>

<script>
export default {
	props: {
		school: {
			required: true,
			type: Object
		}
	}
};
</script>
